import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=65a680ce&scoped=true"
import script from "./Risk.vue?vue&type=script&lang=js"
export * from "./Risk.vue?vue&type=script&lang=js"
import style0 from "./Risk.vue?vue&type=style&index=0&id=65a680ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a680ce",
  null
  
)

export default component.exports